import { c as _c } from "react/compiler-runtime";
import { ENDORSEMENT_NAME_TO_FEATURE_ACCESS_LABEL } from '@bridge/constants';
import { formatList } from '@bridge/utils';
import { faChevronDown, faCircleInfo, faFile, faLink, faListCheck } from '@icons/classic/regular';
import TaskLayout from './TaskLayout';
import type { TaskLayoutProps } from './TaskLayout';
export function getCustomerTaskNeededFor(endorsements: string[], fallback = 'customer approval'): string {
  return formatList(endorsements.map(endorsement => ENDORSEMENT_NAME_TO_FEATURE_ACCESS_LABEL[endorsement as keyof typeof ENDORSEMENT_NAME_TO_FEATURE_ACCESS_LABEL]).filter(Boolean)) || fallback;
}
function getCustomerTaskIcon(taskType: string | undefined) {
  switch (taskType) {
    case 'info':
      return faCircleInfo;
    case 'complete_link':
      return faLink;
    case 'select':
      return faChevronDown;
    case 'multi_step':
      return faListCheck;
    default:
      return faFile;
  }
}
interface CustomerTaskLayoutProps extends Omit<TaskLayoutProps, 'icon' | 'neededFor'> {
  forEndorsements?: string[];
  neededFor?: string;
  taskType?: string;
}

/** Shared summary row for Dashboard and Admin customer tasks. */
export function CustomerTaskLayout(t0) {
  const $ = _c(14);
  let forEndorsements;
  let neededFor;
  let props;
  let taskType;
  if ($[0] !== t0) {
    ({
      forEndorsements,
      neededFor,
      taskType,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = forEndorsements;
    $[2] = neededFor;
    $[3] = props;
    $[4] = taskType;
  } else {
    forEndorsements = $[1];
    neededFor = $[2];
    props = $[3];
    taskType = $[4];
  }
  let t1;
  if ($[5] !== taskType) {
    t1 = getCustomerTaskIcon(taskType);
    $[5] = taskType;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== forEndorsements || $[8] !== neededFor) {
    t2 = neededFor ?? getCustomerTaskNeededFor(forEndorsements ?? []);
    $[7] = forEndorsements;
    $[8] = neededFor;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t2) {
    t3 = <TaskLayout {...props} icon={t1} neededFor={t2} />;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}